// Third-party
import React from 'react';

// Components
import { LoadingSpinner, CheckmarkIcon, ErrorIcon } from '../common';
import { SecondaryButton } from '../buttons';
import Modal from '@/views/components/modals/AccessibleModal';

// Utils
import { FormattedMessage } from '@/utils/i18n';
import { Status } from '@/types/status';

type Props = {
  onCancel?: () => void;
  show: boolean;
  status?: Status;
  i18nBasePath?: string;
  isDelayed?: boolean;
  withBackdrop?: boolean;
};

const StatusFeedbackModal = (props: Props) => {
  const { status = Status.LOADING, i18nBasePath, isDelayed, withBackdrop } = props;

  const STATUS_COMPONENT = {
    [Status.LOADING]: LoadingSpinner,
    [Status.SUCCESS]: CheckmarkIcon,
    [Status.TRANSFER_ERROR]: ErrorIcon,
    [Status.ERROR]: ErrorIcon,
  };

  const StatusComponent = STATUS_COMPONENT[status];
  const delayedClassName = isDelayed ? 'delayed' : '';

  return (
    <Modal
      show={props.show}
      className={`status-feedback-modal ${status.toLowerCase()} ${delayedClassName}`}
      dialogClassName="modal-dialog-centered"
      backdrop="static"
      backdropClassName={withBackdrop ? 'modal-v2-backdrop' : ''}
    >
      <Modal.Body className="d-flex flex-column">
        <div className="status-container">
          <StatusComponent />
        </div>

        <div className="text-content">
          <h3>
            <FormattedMessage id={`${i18nBasePath}.LoadingModal.${status}.Title`} />
          </h3>
          <p>
            <FormattedMessage id={`${i18nBasePath}.LoadingModal.${status}.Body`} />
          </p>
          <p className="sub-text">
            <FormattedMessage id={`${i18nBasePath}.LoadingModal.${status}.SubText`} />
          </p>
        </div>

        {status !== Status.LOADING && props.onCancel && (
          <SecondaryButton className="cancel-button" onClick={props.onCancel}>
            <FormattedMessage id={`${i18nBasePath}.LoadingModal.${status}.Close`} />
          </SecondaryButton>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default StatusFeedbackModal;
